import { router } from "@inertiajs/react"
import { Link } from "@inertiajs/react"
import { BackofficeLayout } from "@/components/layout/BackofficeLayout"
import { SearchInput } from "@/components/shared/SearchInput"
import { Pagination, PaginationMeta } from "@/components/shared/Pagination"
import { StageBadge } from "@/components/shared/StageBadge"
import { formatDate } from "@/lib/utils"

type RegisteredAddressRow = {
  id: string
  stage: string
  type_name: string
  type_code: string
  jurisdiction_label: string
  business_name: string
  account_name: string
  duration_months: number
  created_at: string
}

type Props = {
  registered_addresses: RegisteredAddressRow[]
  search: string
  pagination: PaginationMeta
}

export default function BackofficeRegisteredAddressesIndex({ registered_addresses, search, pagination }: Props) {
  return (
    <BackofficeLayout title="Registered Address Services" breadcrumbs={[{ label: "Backoffice", href: "/backoffice/dashboard" }, { label: "Registered Addresses" }]}>
      <div className="mb-8">
        <h1 className="text-xl font-semibold tracking-tight">Registered Address Services</h1>
        <p className="text-sm text-muted-foreground">{pagination.total} {pagination.total === 1 ? "service" : "services"}</p>
      </div>

      <SearchInput value={search} placeholder="Search services..." />

      <div className="mt-4">
        {registered_addresses.length === 0 ? (
          <div className="border rounded-lg py-16 text-center">
            <h3 className="text-sm font-medium text-foreground mb-1">No services yet</h3>
          </div>
        ) : (
          <div className="border rounded-lg">
            {registered_addresses.map((ra, i) => (
              <div
                key={ra.id}
                className={`px-4 py-3 cursor-pointer hover:bg-muted/50 transition-colors ${i > 0 ? "border-t" : ""}`}
                onClick={() => router.visit(`/backoffice/registered_addresses/${ra.id}`)}
              >
                <div className="flex items-center justify-between">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <Link href={`/backoffice/registered_addresses/${ra.id}`} className="text-sm font-medium hover:underline">{ra.business_name}</Link>
                      <span className="text-[12px] text-muted-foreground">{ra.type_name}</span>
                    </div>
                    <div className="text-xs text-muted-foreground mt-0.5">
                      {ra.account_name} · {ra.jurisdiction_label || "—"} · {ra.duration_months} months · {formatDate(ra.created_at)}
                    </div>
                  </div>
                  <div className="ml-4">
                    <StageBadge stage={ra.stage} variant="service" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-4">
        <Pagination pagination={pagination} />
      </div>
    </BackofficeLayout>
  )
}
